// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".td-value{overflow-x:auto}.td-value-max-width{width:100%;max-width:95vw}.td-value-max-height{max-height:50vh}", ""]);
// Exports
module.exports = exports;
